    <app-row class="madar--v2 justify-center text-center">
      <app-col cols="12">
        <h3 class="mb-3 h4">{{ "auth.Login.OTPTitle" | translate }}</h3>
      </app-col>

      <app-col cols="12">
        <p class="m-0 text-primary-A500">{{ "auth.Login.EnterOTPCode" | translate}}</p>
      </app-col>

      <app-col cols="12" class="my-7">
        <div class="text-center" dir="ltr">
          <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{length:4, placeholder: '-'}"></ng-otp-input>
        </div>
        <div class="row mt-7" *ngIf="false">
          <p class="col-auto m-0">
            {{ "auth.Login.ResendOTPIn" | translate }}
            <span>00:23</span>
          </p>

          <a class="col-auto ml-auto link text-secondry">{{ "auth.Login.ResendOTP" | translate }}</a>
        </div>
      </app-col>

      <app-col cols="10">
        <button 
          mat-raised-button color="primary"
          [disabled]="otp?.toString().length !== 4 " 
          class="w-100 mb-2" 
          (click)="send.emit(otp);">
          {{ "Buttons.Send" | translate }}
        </button>

        <button 
          mat-stroked-button
          class="w-100" 
          [routerLink]="RoutesUtil.AuthLogin.url()">
          <app-icon name="arrow-left" size="xs" class="text-400 mr-2"></app-icon>
          {{ "Buttons.BackToSignin" | translate }}
        </button>
      </app-col>
    </app-row>
